"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityPlacementSlipDocumentMap = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_placement_slip_generation_entity_1 = require("./opportunity-placement-slip-generation.entity");
const look_up_entity_1 = require("./look-up.entity");
/**
 * Entity for opportunity_placement_slip_document_map table.
 */
let OpportunityPlacementSlipDocumentMap = class OpportunityPlacementSlipDocumentMap {
    constructor(placementSlipId, documentId, documentTypeLid) {
        this.placementSlipId = placementSlipId;
        this.documentId = documentId;
        this.documentTypeLid = documentTypeLid;
    }
};
exports.OpportunityPlacementSlipDocumentMap = OpportunityPlacementSlipDocumentMap;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipDocumentMap.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "placement_slip_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipDocumentMap.prototype, "placementSlipId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "document_id", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipDocumentMap.prototype, "documentId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "document_type_lid", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityPlacementSlipDocumentMap.prototype, "documentTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_placement_slip_generation_entity_1.OpportunityPlacementSlipGeneration, (placementSlip) => placementSlip.documents, { onDelete: "CASCADE" }),
    (0, typeorm_1.JoinColumn)({ name: "placement_slip_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityPlacementSlipDocumentMap.prototype, "placementSlip", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => look_up_entity_1.LookUp, (lookup) => lookup.id, { onDelete: "CASCADE" }),
    (0, typeorm_1.JoinColumn)({ name: "document_type_lid" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityPlacementSlipDocumentMap.prototype, "documentType", void 0);
exports.OpportunityPlacementSlipDocumentMap = OpportunityPlacementSlipDocumentMap = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_placement_slip_document_map"),
    tslib_1.__metadata("design:paramtypes", [Number, Number, Number])
], OpportunityPlacementSlipDocumentMap);
